/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Home_StartInputs */

const en_gc_home_start = /** @type {(inputs: Gc_Home_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open GridCraft`)
};

const zh_gc_home_start = /** @type {(inputs: Gc_Home_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打开 GridCraft`)
};

/**
* | output |
* | --- |
* | "Open GridCraft" |
*
* @param {Gc_Home_StartInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_home_start = /** @type {((inputs?: Gc_Home_StartInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Home_StartInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_home_start(inputs)
	return zh_gc_home_start(inputs)
});
export { gc_home_start as "gc.home.start" }